import styled from 'styled-components'
import { Link as RRLink } from 'react-router-dom'

const scope = 'Link'
export const Link = styled(RRLink)`

 `
Link.displayName = `${scope}`